type BreadCrumbParentItem = {
  text: string
  path: string
};

type BreadCrumbProps = {
  ancestors: BreadCrumbParentItem[]
  descendant: string
};

const BreadCrumb: React.FC<BreadCrumbProps> = ({ancestors, descendant}) => {
  return (
    <div className="container px-0">
      <nav aria-label="breadcrumb ml-3">
        <ul className="breadcrumb text-sm ml-3">
          {ancestors.map((ancestor) => (
            <li className="breadcrumb-item" key={ancestor.text}>
              <a href={ancestor.path} className="text-muted">{ancestor.text}</a>
            </li>
          ))}
          <li className="breadcrumb-item  active">
            <span className="text-muted">{descendant}</span>
          </li>
        </ul>
      </nav>
    </div>
  )
};

export default BreadCrumb;
